// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "" + {"354":"14bb80d8d25c2b3231a0","785":"362b8f6314565596bc10","810":"b6836f37c69e1f303278"}[chunkId] + ".bundle.js";
};